import type { App } from 'vue';
import { createApp } from 'vue'
import Application from './App.vue'

import router from './router'
import i18n from './i18n'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Swiper, SwiperSlide } from "swiper/vue";

import "./assets/styles/styles.css"
import "./assets/icons"

import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";

import cache from './cache'
import components from './components'

const initApp = async (): Promise<App<Element>> => {
    await cache.init();

    const app = createApp(Application)

    app.use(router)
    app.use(i18n)

    app.component('font-awesome-icon', FontAwesomeIcon)
    app.component('Swiper', Swiper)
    app.component('SwiperSlide', SwiperSlide)

    for(const component in components) {
        app.component(component, components[component])
    }

    return app;
}

const main = async () => {
    const app = await initApp()
    app.mount('#app')
}

main();